export type McpEnvLabel = 'local' | 'dev' | 'qa' | 'prod';

export const deriveMcpEnvLabel = (hostname: string): McpEnvLabel => {
  const host = hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return 'local';
  if (host.includes('dev.')) return 'dev';
  if (host.includes('qa.')) return 'qa';
  return 'prod';
};
